import { useStoreon } from 'storeon/react';

export type Experiment = {
  externalId: string;
  internalId: string;
};

export const useLangPickerExperiment = () => {
  const { model } = useStoreon('model');
  return !!model?.experiments?.some(
    (experiment: Experiment) => experiment.internalId === 'header_lang_picker'
  );
};
